export default __webpack_public_path__ + "static/media/lu.fad772fa.svg";